import Button from "../Button/Button";
import LocationIcon from "../../../assets/icons/location.png";
import "./location.css";
import { useParams } from "react-router-dom";

const Location = ({ onClick }) => {
  const { plantCode } = useParams();
  const getLocationPlaceholder = () => {
    if (!plantCode) {
      return "Loading...";
    } else {
      if (plantCode) {
        return plantCode;
      } else {
        return "Select Location";
      }
    }
  };
  return (
    <Button
      btnClass={`${!plantCode ? "loading" : ""}`}
      onClick={onClick}
      icon={LocationIcon}
      placeholder={getLocationPlaceholder()}
    />
  );
};

export default Location;
